// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1038":"9f77cb14cedd4205","6850":"880d9beb357a3d9c"}[chunkId] + ".js";
};